import { useScreen } from 'vue-screen'
import { debounce } from '@/utils/navigation/async'

const SMALL_BREAKPOINT = 1023

export function createIntersectionEvent(id, { element, rootMargin, threshold }, { commit, remove }) {
	if (!element || typeof IntersectionObserver === 'undefined') {
		return false
	}

	let revertCommit = null
	const screen = useScreen()
	const options = {
		rootMargin: rootMargin ?? (screen.width > SMALL_BREAKPOINT ? '0% -25% 0% -25%' : '-70% 0% -25% 0%'),
		threshold: threshold ?? 0,
	}

	const intersectionObserver = new IntersectionObserver(([entry]) => onIntersection(entry), options)
	const onResize = debounce(() => {
		intersectionObserver.unobserve(element)
		intersectionObserver.observe(element)
	}, 100)

	function onIntersection({ isIntersecting }) {
		if (isIntersecting && !revertCommit) {
			revertCommit = commit()
		}

		if (!isIntersecting && revertCommit) {
			revertCommit()
			revertCommit = null
		}
	}

	function destroy() {
		revertCommit?.()
		revertCommit = null
		intersectionObserver.disconnect()
		window.removeEventListener('resize', onResize)
		remove()
	}

	intersectionObserver.observe(element)
	window.addEventListener('resize', onResize)

	return {
		id,
		type: 'intersection',
		destroy,
	}
}
